import React, {Component, PropTypes} from 'react';

export default class DynamicTextButton extends Component {
  constructor(props) {
    super(props);
    this._openDynamicTextDialog = this._openDynamicTextDialog.bind(this);
  }

  _openDynamicTextDialog() {
    this.props.changeHandler({
      type: 'openDynamicTextDialog',
      value: this.props.defaultText
    });
  }

  render() {
    return (
      <button
        className='dtr-button text-action-button'
        type='button'
        onClick={this._openDynamicTextDialog}
      >
        Dynamic Text
      </button>
    );
  }

}

DynamicTextButton.propTypes = {
  defaultText: PropTypes.string,
  changeHandler: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/action-tab-content-components/dynamic-text-button.jsx